<template>
    <section class="_present" :style="{ 'min-height': `${ windowHeight }px` }">
        <Modal v-if="shouldModalDisplay"
            :modalType="modalType"
            @close="shouldModalDisplay = false"
            @download="$router.push('/download-app')" />
        <div class="_present_header" />
        <ul class="_present_list">
            <li v-for="(book, index) in list" :key="index">
                <div class="_present_list_image" :class="{ 'active': book.isReceive }">
                    <img :src="book.image" alt="" />
                    <div />
                </div>
                <div class="_present_list_info">
                    <p>《{{ book.title }}》</p>
                    <p>{{ book.recommendWord }}</p>
                    <div @click="handleClick(book)">
                        <p>原价 ￥{{ book.marketPrice }}</p>
                        <p :class="{ 'active': book.isReceive }">{{ book.isReceive ? '免费阅读' : '赠书' }}</p>
                    </div>
                </div>
            </li>
        </ul>
    </section>
</template>

<script>
    import Modal from './Modal'
    import api from '@edu-fe/api'
    import login from '@edu-fe/login'
    import shareByApp, { getInfomation } from '../../lib/shareByApp'
    import Cookie from 'js-cookie'
    
    export default {
        name: 'Present',
        components: {
            Modal
        },
        data() {
            return {
                windowHeight: 0,
                shouldModalDisplay: false,
                modalType: 1,
                list: [],
                activityId: '',
                timer: null
            }
        },
        created() {
            this.windowHeight = window.innerHeight

            api.present.fetchBookList().then(res => {
                if(res.code === 1) {
                    const { activityBookVoList, shareUserId, activityId } = res.data
                    this.list = activityBookVoList
                    this.activityId = activityId
                } else {
                    this.$toast.show({ message: '网络错误' })
                }
            })
        },
        beforeDestroy() {
            clearInterval(this.timer)
        },
        methods: {
            createLooper() {
                this.timer = setInterval(() => {
                    getInfomation().then(data => {
                        if(data && data.wpsid) {
                            clearInterval(this.timer)
                        }
                    })
                }, 300)
            },
            handleClick(book) {
                const { isReceive } = book
                if(isReceive) {
                    this.shouldModalDisplay = true
                    this.modalType = 2
                } else {
                    api.present.fetchShareID({
                        courseId: book.courseId,
                        activityId: this.activityId
                    }).then(res => {
                        if(res.code === 1) {
                            const { shareId, image: imageUrl, shareContent: title } = res.data
                            const shareUrl = `${ window.location.origin }/bookDetail?shareId=${ shareId }`
                            
                            shareByApp({
                                shareUrl,
                                imageUrl,
                                title,
                                content: '探寻知识，跨越平庸'
                            })
                        } else if(res.code === -2) { // 未登录
                            this.$toast.show({ message: '您还没有登录哦~' })
                            login.login()
                            this.createLooper()
                        } else {
                            this.$toast.show({ message: '网络错误' })
                        }
                    })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../style/main';

    ._present {
        min-height: 100%;
        background-color: #fafafa;
        font-family: PingFang SC;
        
        &_header {
            position: relative;
            height: rem(360);
            background: url('./images/banner.png') center no-repeat;
            background-size: cover;

            // &::before {
            //     content: '赠书给好友，领取后你也永久获得，5本都有机会获得。每人每期领取好友赠书限1本，每周五更新。';
            //     position: absolute;
            //     top: rem(155);
            //     left: rem(55);
            //     width: rem(470);
            //     line-height: 1.4;
            //     font-size: rem(28);
            //     color: #fff;
            // }
        }

        &_list {
            position: relative;
            z-index: 1;
            margin-top: rem(-40);
            padding: 0 rem(30);

            li {
                display: flex;
                align-items: center;
                padding: rem(15) rem(20);
                border-radius: rem(10);
                box-shadow: 0 rem(20) rem(38) #f0f0f0;
                background-color: #fff;

                &:not(:first-child) {
                    margin-top: rem(40);
                }
            }

            &_image {
                overflow: hidden;
                position: relative;
                width: rem(155);
                height: rem(190);
                border-radius: rem(5);
                
                > img {
                    display: block;
                    width: 100%;
                    height: 100%;
                }

                &.active {
                    > div {
                        position: absolute;
                        top: rem(10);
                        left: 0;
                        height: rem(26);
                        line-height: rem(26);
                        border-top-right-radius: rem(10);
                        border-bottom-right-radius: rem(10);
                        background-color: #fdae00;
                        font-size: 12px;
                        color: #fff;
                        
                        &::before {
                            content: '已获得';
                            display: block;
                            transform: scale(.7);
                            transform-origin: center;
                            line-height: 1;
                        }
                    }
                }
            }

            &_info {
                flex: 1;
                margin-left: rem(20);
                line-height: 1.5;
                text-align: left;
                
                > p {
                    &:first-child {
                        font-size: rem(32);
                        color: #333;
                    }

                    &:nth-child(2) {
                        margin: rem(6) 0;
                        font-size: rem(24);
                        color: #999;
                    }
                }

                > div:last-child {
                    display: flex;
                    align-items: center;

                    > p {
                        &:first-child {
                            flex: 1;
                            text-decoration: line-through;
                            font-size: rem(24);
                            color: #999;
                        }

                        &:last-child {
                            padding: rem(10) 0;
                            width: rem(150);
                            border-radius: rem(10);
                            background-color: #ff7253;
                            text-align: center;
                            font-size: rem(30);
                            font-weight: bold;
                            color: #fff;

                            &.active {
                                width: rem(200);
                                background-image: linear-gradient(to right, #ffb500, #f48f00);
                            }
                        }
                    }
                }
            }
        }
    }
</style>
